import {z} from '@hono/zod-openapi';

export const supportTrainingCheckStatusSchema = z.enum(['ok', 'warning']);

export type SupportTrainingCheckStatus = z.infer<typeof supportTrainingCheckStatusSchema>;

export const supportTrainingResultSchema = z.object({
  summary: z.string(),
  checks: z.array(
    z.object({
      name: z.string(),
      status: supportTrainingCheckStatusSchema,
    })
  ),
});

export type SupportTrainingResult = z.infer<typeof supportTrainingResultSchema>;
